import { createFileRoute } from '@tanstack/react-router'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { browserSupportsWebAuthn } from '@simplewebauthn/browser'

import { useTRPC } from '@/trpc'
import { useAuth } from '@/auth/AuthContext'
import EditUserForm from '@/admin/EditUserForm'
import PasskeyCreate from '@/auth/PasskeyCreate'

import $form from '@tandem/ui/form.css'
import $type from '@tandem/ui/type.css'
import $card from '@tandem/ui/card.css'
import $layout from '@tandem/ui/layout.css'
import clsx from 'clsx'
import { useToast } from '@tandem/ui/Toast'
import $ from './-styles.css'

export const Route = createFileRoute('/settings/')({
  component: SettingsPage,
})

function SettingsPage() {
  let trpc = useTRPC()
  let { user: authUser } = useAuth()
  let queryClient = useQueryClient()
  let keys = useQuery(trpc.auth.passkeys.list.queryOptions(undefined, { enabled: !!authUser }))
  let removeKey = useMutation(trpc.auth.passkeys.remove.mutationOptions({
    onSuccess: () => queryClient.invalidateQueries(trpc.auth.passkeys.list.queryFilter()),
  }))

  let toast = useToast()

  let userQuery = useQuery(trpc.user.get.queryOptions(authUser?.id ?? 0, {
    enabled: !!authUser?.id,
  }))

  let user = userQuery.data

  if (!authUser || !user) {
    return <div>Загрузка...</div>
  }

  return (
    <div class={clsx('container', $.container)}>
      <h2>Настройки</h2>
      <div class={$card.rect}>
        <EditUserForm user={user} />
      </div>
      <div class={clsx($card.rect, $layout.col)}>
        <h3>Ключи доступа</h3>
        <p>Вход без письма с подтверждением на вашем устройстве.</p>
        {keys.data?.map(key => <div key={key.id} class={$layout.row}>
          <span>{key.name}</span>{' '}
          <button type='button' class='plain' disabled={removeKey.isPending} onClick={() => {
            if (window.confirm(`Удалить ключ «${key.name}»? Вход по почте останется доступен.`)) removeKey.mutate({ id: key.id })
          }}>Удалить</button>
        </div>)}
        {browserSupportsWebAuthn() && <PasskeyCreate />}
      </div>
    </div>
  )
}
